export default __webpack_public_path__ + "/img/002-sk-banner-mob.12403e13.jpg";